import { render } from "./answer.vue?vue&type=template&id=11a1576f&scoped=true&ts=true"
import script from "./answer.vue?vue&type=script&lang=ts"
export * from "./answer.vue?vue&type=script&lang=ts"

import "./answer.vue?vue&type=style&index=0&id=11a1576f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a1576f"]])

export default __exports__